<template>
  <div class="chuKuZuoyeWarp">
    <div class="chuKuZuoyeWarp-body">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="提现申请" name="first">
          <div ref="searchBox">
            <!-- <div class="detailsTitle">
              <h4>提现管理</h4>
            </div> -->
            <!-- 查询条件 -->
            <div class="inpBox">
              <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="申请日期:">
                  <el-date-picker
                    v-model="formInline.ruKuStartTime"
                    size="mini"
                    style="width: 195px"
                    placeholder="选择日期"
                    type="date"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker
                  >&nbsp; &nbsp;- &nbsp;&nbsp;&nbsp;
                  <el-date-picker
                    v-model="formInline.ruKuEndTime"
                    size="mini"
                    style="width: 195px"
                    placeholder="选择日期"
                    type="date"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="提现用户:">
                  <el-input @input="chengeInput($event)" clearable v-model="formInline.yonghu" size="mini" placeholder="请输入提现用户"></el-input>
                </el-form-item>
                <el-form-item label="提现订单/运单:">
                  <el-input @input="chengeInput($event)" clearable v-model="formInline.tixianHao" size="mini" placeholder="请输入提现订单/运单"></el-input>
                </el-form-item>
                <el-form-item label="状态:">
                  <el-select size="mini" v-model="formInline.goodsType" placeholder="请选择状态" style="width: 175px">
                    <el-option
                      v-for="item in typeData"
                      :label="item.show_name"
                      :key="item.show_name"
                      :value="item.item_no"
                    ></el-option>
                  </el-select>
                </el-form-item>
                 <el-form-item label="是否自动提现:" prop="isAutoWithdraw">
                  <el-select size="mini"   v-model="formInline.isAutoWithdraw"   placeholder="请选择">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="2"></el-option>
                  </el-select>
              </el-form-item>
                <el-form-item>
                  <div style="margin-left: 20px">
                    <el-button type="primary" size="mini" @click="chaxun" btnCode="00JP006B001" v-if="btnFlg[0]">查询 </el-button>
                    <el-button type="primary" size="mini" @click="chongZhi" btnCode="00JP006B002" v-if="btnFlg[1]">重置</el-button>
                    <el-button type="primary" size="mini" @click="tiXianClick" btnCode="00JP006B003" v-if="btnFlg[2]">提现</el-button>
                    <el-button type="primary" size="mini" @click="daochu" :disabled="isDisableDaochu" btnCode="00JP006B005" v-if="btnFlg[4]">导出</el-button>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!--表格1-->
          <div class="chuKuZuoyeWarp-body-table" :style="{ height: h }">
            <el-table
              height="100%"
              size="mini"
              ref="tabref"
              :data="cangchuTableData"
              style="width: 100%"
              class="elTab"
              border
              highlight-current-row
              @row-click="dianjixuanzhong"
              @selection-change="handleSelectionChange"
              :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
            >
              <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
              <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
              <!-- <el-table-column  :show-overflow-tooltip="true" prop="businessNo" label="操作" align="center" width="80">
                <template slot-scope="scope">
                  <span v-if="scope.row.drawalStatus=='已提现'">
                    <el-button type="text" size="mini" @click="changeData(scope.row)" btnCode="00JP006B004" v-if="btnFlg[3]">修改</el-button>
                  </span>
                  <span v-else-if="scope.row.drawalStatus!=='已提现'">
                    <el-button type="primary" size="mini" @click="seeClickNO(scope.row)" btnCode="00JP006B003" v-if="btnFlg[2]">提现</el-button>
                  </span>
                </template>
              </el-table-column> -->
              <el-table-column prop="recCustomerName" label="提现用户" :show-overflow-tooltip="true" align="center" :formatter="emptyFn" width="320"></el-table-column>
               <el-table-column prop="drawalStatus" label="提现状态" :show-overflow-tooltip="true" align="center" :formatter="emptyFn" width="100">
                  <template slot-scope="scope">
                   <div>
                  <span v-if="scope.row.drawalStatus =='已提现'" >已提现</span>
                  <span v-if="scope.row.drawalStatus =='提现中'" style="color: red">提现中</span>
                  <span v-if="scope.row.drawalStatus =='提现失败'">提现失败</span>
                  </div>
                 </template>
              </el-table-column>

              <el-table-column prop="accountCode" label="钱包账号" :show-overflow-tooltip="true" align="center" :formatter="emptyFn" width="150"></el-table-column>
              <el-table-column label="资金流水号" width="180">
                <template slot-scope="scope">
                  <span style="color: #0e6eec;cursor: pointer;" @click="huidanFn(scope.row)">{{scope.row.capitalSerialno}}</span>
                </template>
              </el-table-column>
              <el-table-column property="isAutoWithdraw" width="120" label="是否自动提现">
                <template scope="scope">{{[ "是", "否",][scope.row.isAutoWithdraw-1]}}</template>
              </el-table-column>
              <el-table-column prop="accountType" label="用户类型" :show-overflow-tooltip="true" align="center" :formatter="emptyFn" width="100" ></el-table-column>
              <el-table-column prop="businessNo" label="提现订单/运单" :show-overflow-tooltip="true" align="center" :formatter="emptyFn" width="200"></el-table-column>
              <el-table-column prop="drawalMoney" label="提现金额(元)"  :show-overflow-tooltip="true" align="center" :formatter="emptyFn" width="150"></el-table-column>
              <el-table-column prop="bankAccount" label="提现银行卡" :show-overflow-tooltip="true" align="center" :formatter="emptyFn" width="200"></el-table-column>
              <el-table-column prop="openingBank" label="提现开户银行" :show-overflow-tooltip="true" align="center" width="240"></el-table-column>
              <el-table-column prop="drawalFailReason" label="备注信息" :show-overflow-tooltip="true" align="center" :formatter="emptyFn" width="270"></el-table-column>
              <el-table-column prop="applyTime" label="申请时间" align="center" :formatter="dateFormat" width="160"></el-table-column>
              <el-table-column prop="drawalTime" label="提现时间" :formatter="dateFormat" align="center" width="160"></el-table-column>
              <el-table-column prop="capitalTranstime" label="转账时间" :formatter="dateFormat" align="center" width="160"></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="seeClick(scope.row)" v-if="scope.row.drawalStatus =='已提现'&&scope.row.isAutoWithdraw==2">提现凭证</el-button>
                  <span v-else-if="scope.row.drawalStatus =='待提现'||scope.row.isAutoWithdraw==1">-</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--分页-->
          <div class="pags" style="text-align: left">
            <el-pagination
              background
              @current-change="handleCurrentChangeA"
              :current-page="current"
              :page-size="pagesize"
              :page-sizes="[50,100,150, 200, 250]"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChangeA"
              :total="total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="线下提现记录" name="second">
          <div ref="searchBox">
            <!-- 查询条件 -->
            <div class="inpBox">
              <el-form :inline="true" :model="recordForm" class="demo-form-inline">
                <el-form-item label="提现日期:">
                  <el-date-picker
                    v-model="recordForm.startTime"
                    size="mini"
                    style="width: 195px"
                    placeholder="选择日期"
                    type="date"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker
                  >&nbsp; &nbsp;- &nbsp;&nbsp;&nbsp;
                  <el-date-picker
                    v-model="recordForm.endTime"
                    size="mini"
                    style="width: 195px"
                    placeholder="选择日期"
                    type="date"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="提现用户:">
                  <el-input @input="chengeInput($event)" clearable v-model="recordForm.customerName" size="mini" placeholder="请输入提现用户"></el-input>
                </el-form-item>
                <el-form-item>
                  <div style="margin-left: 20px">
                    <el-button type="primary" size="mini" @click="recordChaxun" btnCode="00JP006B008" v-if="btnFlg[7]">查询</el-button>
                    <el-button type="primary" size="mini" @click="recordChongZhi" btnCode="00JP006B009" v-if="btnFlg[8]">重置</el-button>
                    <el-button type="primary" size="mini" @click="recordDaochu" btnCode="00JP006B00A" v-if="btnFlg[9]" :disabled="isDisableRecordDaochu">导出</el-button>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <!--表格2-->
          <div class="chuKuZuoyeWarp-body-table" :style="{ height: h }">
            <el-table
              border
              height="100%"
              size="mini"
              ref="recordTableData"
              :data="recordTableData"
              style="width: 100%"
              class="elTab"
              highlight-current-row
              @row-click="dianjixuanzhongJiLu"
              :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
            >
              <!-- <el-table-column type="index" align="center" label="序号" width="60"></el-table-column> -->
              <el-table-column prop="customerName" label="操作" align="center" width="250">
                <template slot-scope="scope">
                  <el-button type="text" size="mini"  btnCode="00JP006B006" v-if="btnFlg[5]" @click="recordDetailsClick(scope.row)">详情</el-button>
                  <el-button type="text" size="mini"  btnCode="00JP006B007" v-if="btnFlg[6]" @click="pingZheng(scope.row)">凭证</el-button>
                  <el-button type="text" size="mini"  btnCode="00JP006B004" v-if="btnFlg[3]" @click="changeData(scope.row)" >修改</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="capitalSerialno" :show-overflow-tooltip="true" label="资金流水号" :formatter="emptyFn" align="center" width="150" ></el-table-column>
              <el-table-column prop="customerName" :show-overflow-tooltip="true" label="提现用户" align="center" width="150" :formatter="emptyFn"></el-table-column>
              <el-table-column prop="accountCode" label="钱包账号" align="center" width="150" ></el-table-column>
              <el-table-column prop="accountType" label="用户类型" align="center" width="150" >
                <template slot-scope="scope">
                  <div>
                  <span v-if="scope.row.accountType == '0'">平台</span>
                  <span v-if="scope.row.accountType == '1'">货主</span>
                  <span v-if="scope.row.accountType == '2'">司机</span>
                  <span v-if="scope.row.accountType == '3'">车队</span>
                  <span v-if="scope.row.accountType == '4'">车队长</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="drawalMoney" :show-overflow-tooltip="true" :formatter="emptyFn" label="提现金额(元)" align="center" width="150" ></el-table-column>
              <el-table-column prop="bankAccount" :show-overflow-tooltip="true" label="提现银行卡" align="center" width="150" :formatter="emptyFn"></el-table-column>
              <el-table-column prop="openingBank" :show-overflow-tooltip="true" label="开户银行" align="center" width="150" :formatter="emptyFn"></el-table-column>
              <el-table-column prop="" label="转账时间" align="center" width="170">
                <template slot-scope="scope">
                  <span v-if="scope.row.capitalTranstime == null">-</span>
                  <span v-if="scope.row.capitalTranstime != null">{{scope.row.capitalTranstime | dateFormat}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="提现时间" align="center" width="170">
                <template slot-scope="scope">
                  <span v-if="scope.row.createTime == null">-</span>
                  <span v-if="scope.row.createTime != null">{{scope.row.createTime | dateFormat}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--分页-->
          <div class="pags" style="text-align: left">
            <el-pagination
              background
              @current-change="handleCurrentChangeB"
              :current-page="recordForm.pageNo"
              :page-size="recordForm.pageSize"
              :page-sizes="[10, 20, 30, 40, 50]"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChangeB"
              :total="total1"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 订单详情弹窗 -->
    <div>
      <el-dialog
        title="提现"
        :visible.sync="detailsMark"
        :close-on-click-modal="false"
        width="40%"
        center
        :before-close="handleClose"
      >
        <div v-loading="loading1">
          <el-form ref="goodform" enctype="multipart/form-data" :model="goodform" label-width="150px" size="mini" center>
            <div>
              <div>
                <el-form-item label="提现用户 :">
                  <span v-if="goodform.productTypeName">{{goodform.productTypeName}}</span>
                  <span v-else-if="!goodform.productTypeName">{{goodform.productTypeName}}</span>
                </el-form-item>
                <el-form-item label="提现银行卡 :">
                  <span v-if="goodform.bankAccount !== ''">{{goodform.bankAccount}}</span>
                  <span v-else-if="goodform.bankAccount == ''">--</span>
                </el-form-item>
                <el-form-item label="提现开户行 :">
                  <span v-if="goodform.openingBank !== ''">{{goodform.openingBank}}</span>
                  <span v-else-if="goodform.openingBank == ''">--</span>
                </el-form-item>
                <el-form-item label="提现订单/运单 :" v-if="formFlag !== 1">
                  <span v-if="goodform.businessNo">{{goodform.businessNo}}</span>
                  <span v-else-if="!goodform.businessNo">--</span>
                </el-form-item>
                <el-form-item label="提现金额 :">
                  <span style="color: red" v-if="goodform.drawalMoney">{{goodform.drawalMoney}}</span>
                  <span v-else-if="!goodform.drawalMoney">--</span>
                  <span class>元</span>
                </el-form-item>
              </div>
              <div>
                <div v-if="formFlag == 1">
                  <el-form-item label="资金流水号:">
                    <el-input @input="chengeInput($event)" clearable v-model="goodform.liushui" size="mini" style="width: 195px" placeholder="请输入资金流水号"></el-input>
                  </el-form-item>
                  <!-- <el-form-item label="转账时间:">
                    <el-date-picker
                      v-model="goodform.timeZhuan"
                      size="mini"
                      style="width:195px"
                      placeholder="选择日期"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                  </el-form-item>-->
                </div>
                <div v-else-if="formFlag == 0">
                  <div style="margin-bottom: 15px">
                    <el-form-item label="资金流水号:" prop="liushui"
                      :rules="[
                        {
                          required: true,
                          message: '请输入资金流水号',
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input @input="chengeInput($event)" clearable maxlength="50" v-model="goodform.liushui" size="mini" style="width: 195px" placeholder="请输入资金流水号"></el-input>
                    </el-form-item>
                  </div>
                  <el-form-item label="转账时间:" prop="timeZhuan"
                    :rules="[
                      {
                        required: true,
                        message: '请输入转账时间',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-date-picker
                      v-model="goodform.timeZhuan"
                      size="mini"
                      style="width: 195px"
                      placeholder="选择日期"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                  </el-form-item>
                </div>
                <hr style="margin-top: 15px" />
                <el-form-item label="转账凭证 :" >
                  <div>
                    <el-upload
                      action
                      :file-list="listImg"
                      ref="upload"
                      :auto-upload="false"
                      :on-change="imgPreview"
                      list-type="picture-card"
                      accept="image/*"
                      :limit="1"
                      :on-remove="handleRemove"
                      :class="[isAddImg ? 'hidden' : '']"
                    ></el-upload>
                  </div>
                </el-form-item>
              </div>
            </div>
          </el-form>
          <!-- ----------------------------------------------------------------------------------运单 -->
          <div style="width: 170px; margin: 15px auto">
            <el-button type="primary" @click="remarkOk('goodform')">确认提现</el-button>
            <el-button type="primary" @click="quxiao">取消</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 提现记录修改弹窗 -->
    <div>
      <el-dialog title="修改" :visible.sync="changeDetailsMark" :close-on-click-modal="false" width="500" center :before-close="handleClose">
        <div v-loading="loading2">
          <el-form ref="changeForm" enctype="multipart/form-data" :model="changeForm" label-width="150px" size="mini" center>
            <div>
              <div>
                <div v-if="formFlag == 1" >
                  <el-form-item label="资金流水号:" prop="liushui"  :rules="[
                        {
                          required: true,
                          message: '请输入资金流水号',
                          trigger: 'blur',
                        },
                      ]">
                    <el-input @input="chengeInput($event)" clearable v-model="changeForm.liushui" size="mini" style="width: 195px" placeholder="请输入资金流水号"></el-input>
                  </el-form-item>
                </div>
                <div >
                  <div style="margin-bottom: 15px" v-if="formFlag == 0">
                    <el-form-item label="资金流水号:" prop="liushui"
                      :rules="[
                        {
                          required: true,
                          message: '请输入资金流水号',
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input @input="chengeInput($event)" clearable maxlength="50" v-model="changeForm.liushui" size="mini" style="width: 195px" placeholder="请输入资金流水号"></el-input>
                    </el-form-item>
                  </div>
                  <el-form-item label="转账时间:" prop="timeZhuan" v-if="formFlag == 0"
                    :rules="[
                      {
                        required: true,
                        message: '请输入转账时间',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-date-picker
                      v-model="changeForm.timeZhuan"
                      size="mini"
                      style="width: 195px"
                      placeholder="选择日期"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                  </el-form-item>
                </div>

                <hr style="margin-top: 15px" />
                <el-form-item label="转账凭证 :">
                  <div v-if="srcFlag == 0" class="changeimg">
                    <img :src="src2" />
                    <span>
                      <el-button type="text" @click="changeImg">修改</el-button>
                    </span>
                  </div>
                  <div v-else-if="srcFlag == 1">
                    <el-upload
                      action
                      :file-list="listImg"
                      ref="upload"
                      :auto-upload="false"
                      :on-change="imgPreview"
                      list-type="picture-card"
                      accept="image/*"
                      :limit="1"
                      :on-remove="handleRemove"
                      :class="[isAddImg ? 'hidden' : '']"
                    ></el-upload>
                  </div>
                </el-form-item>
              </div>
            </div>
          </el-form>
          <!-- ----------------------------------------------------------------------------------运单 -->
          <div style="width: 170px; margin: 15px auto">
            <el-button type="primary" @click="changeOk('changeForm')">确认修改</el-button>
            <el-button type="primary" @click="quxiao">取消</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 查看凭证弹窗 -->
    <div v-loading="loading">
      <el-dialog title="查看凭证" :visible.sync="imgMark" :close-on-click-modal="false" width="500" center :before-close="handleClose" custom-class="el-dialog--center">
        <div class="block">
          <span class="demonstration"></span>
          <el-image :src="src"></el-image>
        </div>
        <!-- ----------------------------------------------------------------------------------运单 -->
        <div style="margin: 15px auto" class="el-dialog--center">
          <el-button type="primary" @click="quxiao">关闭</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 提现申请-提现弹框 -->
    <div class="addMarkBox">
        <el-dialog
          custom-class="el-dialog--center"
          title="提现"
          :visible.sync="ownerMark"
          :close-on-click-modal="false"
          width="600"
          center
          :before-close="ownerHandleClose"
        >
          <div v-loading="loading1" style="width:98%; margin:20px auto">
            <div class="owner_top">
              <div>
                提现用户：&nbsp;<span style="font-weight:700;">{{ownerCustomerName}}</span>
              </div>
              <div>
                提现金额合计：&nbsp;<span style="font-weight:700;color:red;">{{ownerDrawalMoney}}</span>
              </div>
            </div>
            <!-- 货主表格 -->
            <div style="margin:20px 0 20px 0;" >
              <el-table
              size="mini"
              ref="ownerTableData"
              :data="ownerTableData"
              style="width: 100%"
              class="elTab"
              border
              highlight-current-row
              :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
            >
              <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
              <el-table-column v-if="zhuanZhangTimeShow" prop="businessNo" label="提现订单/运单"  :show-overflow-tooltip="true" align="center"></el-table-column>
              <el-table-column prop="drawalMoney" label="提现金额"  :show-overflow-tooltip="true" align="center" :formatter="emptyFn" ></el-table-column>
              <el-table-column prop="applyTime" label="申请时间" align="center" :formatter="dateFormat" ></el-table-column>
            </el-table>
            </div>
            <div class="owner_top2">
              <div>
                提现银行卡：&nbsp;<span style="font-weight:700;">{{ownerBankAccount}}</span>
              </div>
              <div>
                提现开户行：&nbsp;<span style="font-weight:700;">{{ownerOpeningBank}}</span>
              </div>
            </div>
            <!--form表单-->
            <el-form
              :model="ownerFormData"
              ref="ownerFormData"
              :rules="rules"
              label-width="110px"
              class="demo-dynamic"
              style="margin: 20px 0 20px -15px;"
            >
              <el-form-item label="资金流水号：" prop="capitalFlow">
                <el-input maxlength="200" placeholder="请输入资金流水号" size="mini" v-model="ownerFormData.capitalFlow" style="width:350px;"></el-input>
              </el-form-item>
              <el-form-item label="转账时间：" prop="zhuanZhangTime" v-if="zhuanZhangTimeShow">
                <el-date-picker
                  v-model="ownerFormData.zhuanZhangTime"
                  size="mini"
                  style="width: 195px"
                  placeholder="选择日期"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
              <el-form-item prop="img" label="转账凭证：" class="is-required">
                <div>
                  <el-upload
                    action
                    :file-list="listImg"
                    ref="upload"
                    :auto-upload="false"
                    :on-change="imgPreview"
                    list-type="picture-card"
                    accept="image/*"
                    :limit="1"
                    :on-remove="handleRemove"
                    :class="[isAddImg?'hidden':'']"
                  ></el-upload>
                </div>
              </el-form-item>
            </el-form>
            <div style="margin:15px auto;" class="el-dialog--center">
              <el-button type="primary" @click="ownerConfirm('ownerFormData')">确认提现</el-button>
              <el-button type="primary" @click="ownerQuxiao">取消</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
      <!-- 提现记录详情弹框 -->
    <div class="addMarkBox">
        <el-dialog
          custom-class="el-dialog--center"
          title="详情"
          :visible.sync="recordDetailsMark"
          :close-on-click-modal="false"
          width="600"
          center
          :before-close="recordDetailsClose"
        >
          <div  style="width:98%; margin:20px auto">
            <div class="owner_top">
              <div>
                提现用户：&nbsp;<span style="font-weight:700;">{{recordCustomerName}}</span>
              </div>
              <div>
                提现金额合计：&nbsp;<span style="font-weight:700;color:red;">{{recordDrawalMoney}}元</span>
              </div>
            </div>
            <!-- 表格 -->
            <div style="margin:20px 0 20px 0;" v-loading="loading1">
              <el-table
              height="300"
              size="mini"
              ref="recordDetailsTableData"
              :data="recordDetailsTableData"
              style="width: 100%"
              class="elTab"
              border
              highlight-current-row
              :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
            >
              <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
              <el-table-column  prop="businessNo" v-if="formFlag == '0'" label="提现订单/运单"  :show-overflow-tooltip="true" align="center"></el-table-column>
              <el-table-column prop="drawalMoney" label="提现金额"  :show-overflow-tooltip="true" align="center" :formatter="emptyFn" ></el-table-column>
              <el-table-column prop="applyTime" label="申请时间" align="center" :formatter="dateFormat" ></el-table-column>
            </el-table>
            </div>
            <div style="margin:15px auto;" class="el-dialog--center">
              <el-button type="primary" @click="recordDetailsMark = false">关闭</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
  </div>
</template>
<script>
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import { exportExcel } from '@/utils/fileDown.js'
import {
  tWithdrawalInfoList,
  updateForList, // 确认提现
  bPayDictionaryUploadFile,
  recordList, // 提现记录列表
  exportList, // 提现记录导出
  updateDataForList // 提现记录修改
} from '@/api/common-signature'
import { emptyFn, dateFormat1 } from '@/utils/util'
import { chaKanHuiDan } from '@/utils/chaKanHuiDan'
export default {
  name: 'walletManagement',
  data () {
    let token = window.localStorage.getItem('zhonghouban-tokens')
    var jsonObj = JSON.parse(token)
    return {
      activeName: 'first',
      selectList: [],
      ids: '',
      isDisableDaochu: false,
      isDisableRecordDaochu: false,
      loading1: false,
      loading2: false,
      formFlag: 0,
      drawalStatusFlag: 0,
      loading: false,
      src: '',
      src2: '',
      srcFlag: 0,
      imgMark: false, // 查看凭证
      isAddImg: false,
      listImg: [],
      imgUrl: [],
      imgfile: new FormData(),
      header: {
        Authorization: 'Bearer ' + jsonObj
      },
      dialogVisible: false,
      typeData: [
        {
          show_name: '全部',
          item_no: ''
        },
        {
          show_name: '提现中',
          item_no: '1'
        },
        {
          show_name: '已提现',
          item_no: '0'
        }, {
          show_name: '提现失败',
          item_no: '2'
        }
      ],
      emptyFn: emptyFn,
      // ----订单详情
      srcList: [],
      goodform: {
        liushui: '',
        timeZhuan: ''
      },
      changeDetailsMark: false,
      changeForm: {
        liushui: '',
        timeZhuan: ''
      },
      detailsMark: false,
      num: 0,
      title: '托运合同',
      titleDetail: '订单详情',
      h: '500px',
      xuanzhongArr: [],
      xuanzhongArr2: [],
      cangchuTableData: [],
      // 查询条件
      formInline: {
        goodsType: '1',
        yonghu: '',
        tixianHao: '',
        tuoyun: '',
        ruKuStartTime: '',
        ruKuEndTime: ''
      },
      pagesize: 50,
      current: 1,
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: [
        '00JP006B001',
        '00JP006B002',
        '00JP006B003',
        '00JP006B004',
        '00JP006B005',
        '00JP006B006',
        '00JP006B007',
        '00JP006B008',
        '00JP006B009',
        '00JP006B00A'
      ],
      // 提现申请
      ownerMark: false,
      ownerTableData: [],
      ownerFormData: {
        capitalFlow: '', // 资金流水号
        zhuanZhangTime: '' // 转账时间
      },
      ownerCustomerName: '', // 提现用户
      ownerDrawalMoney: '0.00', // 提现金额合计
      ownerBankAccount: '', // 提现银行卡
      ownerOpeningBank: '', // 提现开户行
      rules: {
        capitalFlow: [
          { required: true, message: '请输入资金流水号', trigger: 'blur' }
        ],
        zhuanZhangTime: [
          { required: true, message: '请选择转账时间', trigger: 'blur' }
        ]
      },
      zhuanZhangTimeShow: false,
      orderFlag: '',
      accountType: '',
      costId: '',
      tiXianIds: [],
      // 提现记录
      jiLuTableList: [],
      recordDetailsMark: false,
      recordForm: {
        pageNo: 1, // 页数
        pageSize: 20 // 条数
      },
      total1: 0,
      recordTableData: [],
      recordCustomerName: '',
      recordDrawalMoney: '',
      recordDetailsTableData: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/userWallet/walletManagement')
    this.tWithdrawalInfoListS()
    // this.getRecordList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 200 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 银行回单
    huidanFn (row) {
      chaKanHuiDan(row.capitalSerialno, row.drawalTime)
    },
    // 判断是否可选
    selectable (row, index) {
      if (row.isAutoWithdraw == 2 || row.payType == 2) {
        return true
      } else {
        return false
      }
    },
    handleClick (tab, event) {
      if (tab.index == 0) {
        this.tWithdrawalInfoListS()
      } else if (tab.index == 1) {
        this.getRecordList()
      }
    },
    chengeInput () {
      this.$forceUpdate()
    },
    // 点击导出
    daochu () {
      if (this.selectList.length == 0) {
        this.$confirm('如不选择数据则默认导出全部，是否确认导出?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            this.isDisableDaochu = true
            setTimeout(() => {
              this.isDisableDaochu = false // 点击一次时隔两秒后才能再次点击
            }, 3000)
            let form = {
              pageNo: this.current, // 页数
              pageSize: this.pagesize, // 条数
              recCustomerName: this.formInline.yonghu, //
              drawalStatus: this.formInline.goodsType, // tixianHao
              businessNo: this.formInline.tixianHao, // tixianHao
              startTime: this.formInline.ruKuStartTime, // 创建开始日 字符型
              endTime: this.formInline.ruKuEndTime // 创建结束日 字符型
            }
            // fetch(
            exportExcel(
              this.global.payName + '/tWithdrawalInfo/exportList',
              form,
              '提现申请信息表'
            )
          })
          .catch(() => {})
      } else {
        this.$confirm('即将导出页面选中数据，是否确认导出?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            this.isDisableDaochu = true
            setTimeout(() => {
              this.isDisableDaochu = false // 点击一次时隔两秒后才能再次点击
            }, 3000)
            let form = {
              ids: this.ids,
              pageNo: this.current, // 页数
              pageSize: this.pagesize, // 条数
              customerName: this.formInline.yonghu, //
              drawalStatus: this.formInline.goodsType, // tixianHao
              businessNo: this.formInline.tixianHao, // tixianHao
              startTime: this.formInline.ruKuStartTime, // 创建开始日 字符型
              endTime: this.formInline.ruKuEndTime // 创建结束日 字符型
            }
            // fetch(
            exportExcel(
              this.global.payName + '/tWithdrawalInfo/exportList',
              form,
              '提现申请信息表'
            )
          })
          .catch(() => {})
      }
    },
    // 图片上传
    handleRemove (file, fileList) {
      console.log(file, fileList)
      if (fileList.length < 1) {
        this.isAddImg = false
      }
      // this.addFrom.vhcPhoto1 = ''
      this.listImg = fileList
    },

    imgPreview (file, fileList) {
      console.log(file, fileList)
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/
      if (regex.test(fileName.toLowerCase())) {
        if (fileList.length < 1) {
          this.isAddImg = false
        } else {
          this.isAddImg = true
        }
      } else {
        fileList.pop()
        this.$alert('请选择图片文件图', '系统提示')
        return false
      }
      this.listImg = fileList
    },
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      if (row.isAutoWithdraw == 1) {

      } else {
        this.$refs.tabref.toggleRowSelection(row)
      }
      this.xuanzhongArr = []
      this.xuanzhongArr = row
      this.num = 0
    },
    // 复选框改变事件
    handleSelectionChange (val) {
      this.selectList = []
      this.selectList = val
      this.selectList.forEach((item, index) => {
        this.xuanzhongArr = item
        // this.selectIdList.push(item.cargoId);
      })
      var arr = []
      val.forEach((item, index) => {
        arr.push(item.id)
      })
      this.ids = arr
      this.ids = this.ids.join(',') // id
    },
    // 点击查看凭证
    seeClick (row) {
      this.imgMark = true
      this.loading = false
      this.src = row.drawalVoucher
    },
    // 点击提现页面
    seeClickNO (row) {
      if (row.accountType == '货主' || row.accountType == '平台') {
        this.formFlag = 1
      } else if (row.accountType == '司机') {
        this.formFlag = 0
      } else if (row.accountType == '车队') {
        this.formFlag = 0
      } else if (row.accountType == '车队长') {
        this.formFlag = 0
      }
      this.listImg = []
      this.isAddImg = false
      this.detailsMark = true
      this.goodform = {}
      this.$set(this.goodform, 'productTypeName', row.customerName)
      this.$set(this.goodform, 'bankAccount', row.bankAccount)
      this.$set(this.goodform, 'drawalMoney', row.drawalMoney)
      this.$set(this.goodform, 'businessNo', row.businessNo)
      this.$set(this.goodform, 'openingBank', row.openingBank)
    },
    // 修改图片
    changeImg () {
      this.srcFlag = 1
    },
    // 点击修改页面
    changeData (row) {
      this.srcFlag = 0
      this.formFlag = 0
      if (row.accountType == '1' || row.accountType == '0') {
        this.formFlag = 1
      } else if (row.accountType == '2') {
        this.formFlag = 0
      } else if (row.accountType == '3') {
        this.formFlag = 0
      } else if (row.accountType == '4') {
        this.formFlag = 0
      }
      this.listImg = []
      this.isAddImg = false
      this.changeDetailsMark = true
      this.changeForm = {}
      var t = new Date(row.capitalTranstime) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (row.capitalTranstime == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      this.$set(this.changeForm, 'productTypeName', row.customerName)
      this.$set(this.changeForm, 'bankAccount', row.bankAccount)
      this.$set(this.changeForm, 'drawalMoney', row.drawalMoney)
      this.$set(this.changeForm, 'businessNo', row.businessNo)
      this.$set(this.changeForm, 'timeZhuan', str)
      this.$set(this.changeForm, 'liushui', row.capitalSerialno)
      this.src2 = row.drawalVoucher
    },
    // 点击关闭弹窗
    handleClose (done) {
      this.detailsMark = false
      this.changeDetailsMark = false
      this.imgMark = false
      this.listImg = []
      this.isAddImg = false
      this.$nextTick(() => {
        if (this.$refs.goodform !== undefined) {
          this.$refs.goodform.resetFields()
        }
        if (this.$refs.changeForm !== undefined) {
          this.$refs.changeForm.resetFields()
        }
      })
    },
    quxiao () {
      this.detailsMark = false
      this.changeDetailsMark = false
      this.imgMark = false
      this.listImg = []
      this.isAddImg = false
      this.$nextTick(() => {
        if (this.$refs.goodform !== undefined) {
          this.$refs.goodform.resetFields()
        }
        if (this.$refs.changeForm !== undefined) {
          this.$refs.changeForm.resetFields()
        }
      })
    },
    remarkOk (formName) {
      // this.detailsMark = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.goodform)
          if (this.listImg.length == 0) {
            DonMessage.error('请先上传凭证')
          } else {
            if (this.listImg.length == 0) {
              DonMessage.error('请选择需要上传的图片!')
            } else {
              let imgfile = new FormData()
              for (var i = 0; i < this.listImg.length; i++) {
                imgfile.append('uploadFile', this.listImg[i].raw)
                console.log(this.listImg[i].raw, ' this.listImg[i].raw')
              }
              // let numId = { changeIdPicture: this.xuanzhongArr.changeId }
              imgfile.append('params', JSON.stringify())
              this.loading1 = true
              bPayDictionaryUploadFile(imgfile)
                .then((res) => {
                  console.log(res, '313')
                  let url = res
                  // 上传图片成功后 - 调用确认提现接口
                  tWithdrawalInfoUpdate({
                    id: this.xuanzhongArr.id, // id
                    drawalVoucher: url, // url
                    capitalSerialno: this.goodform.liushui, // 资金流水
                    capitalTranstime: this.goodform.timeZhuan // 转账时间
                  })
                    .then((res) => {
                      DonMessage.success('操作成功!')
                      this.detailsMark = false
                      this.listImg = []
                      this.isAddImg = false
                      this.loading1 = false

                      this.tWithdrawalInfoListS()
                    })
                    .catch((err) => {
                      this.loading1 = false

                      DonMessage.error(err.message)
                    })
                })
                .catch((err) => {
                  DonMessage.error(err.message)
                })
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改确定
    changeOk (formName) {
      // this.detailsMark = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.srcFlag == 0) {
            this.loading2 = true
            updateDataForList({
              batchWithdrawalId: this.xuanzhongArr2.batchWithdrawalId, // id
              drawalVoucher: this.src2, // url
              ext1: '1',
              capitalSerialno: this.changeForm.liushui, // 资金流水
              capitalTranstime: this.changeForm.timeZhuan // 转账时间
            })
              .then((res) => {
                DonMessage.success('操作成功!')
                this.changeDetailsMark = false
                this.listImg = []
                this.isAddImg = false
                this.loading2 = false
                this.srcFlag = 0
                this.getRecordList()
              })
              .catch((err) => {
                this.loading2 = false
                DonMessage.error(err.message)
              })
          } else if (this.listImg.length == 0) {
            DonMessage.error('请先上传凭证')
          } else {
            if (this.listImg.length == 0) {
              DonMessage.error('请选择需要上传的图片!')
            } else {
              let imgfile = new FormData()
              for (var i = 0; i < this.listImg.length; i++) {
                imgfile.append('uploadFile', this.listImg[i].raw)
              }
              // let numId = { changeIdPicture: this.xuanzhongArr.changeId }
              imgfile.append('params', JSON.stringify())
              this.loading2 = true
              bPayDictionaryUploadFile(imgfile)
                .then((res) => {
                  let url = res
                  // 上传图片成功后 - 调用确认提现接口
                  updateDataForList({
                    batchWithdrawalId: this.xuanzhongArr2.batchWithdrawalId, // id
                    drawalVoucher: url, // url
                    ext1: '2',
                    capitalSerialno: this.changeForm.liushui, // 资金流水
                    capitalTranstime: this.changeForm.timeZhuan // 转账时间
                  })
                    .then((res) => {
                      DonMessage.success('操作成功!')
                      this.changeDetailsMark = false
                      this.listImg = []
                      this.srcFlag = 0
                      this.isAddImg = false
                      this.loading2 = false
                      this.getRecordList()
                    })
                    .catch((err) => {
                      this.loading2 = false
                      DonMessage.error(err.message)
                    })
                })
                .catch((err) => {
                  DonMessage.error(err.message)
                })
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 主数据
    tWithdrawalInfoListS () {
      tWithdrawalInfoList({
        pageNo: this.current, // 页数
        pageSize: this.pagesize, // 条数
        customerName: this.formInline.yonghu, //
        drawalStatus: this.formInline.goodsType, // tixianHao
        businessNo: this.formInline.tixianHao, // tixianHao
        startTime: this.formInline.ruKuStartTime, // 创建开始日 字符型
        endTime: this.formInline.ruKuEndTime, // 创建结束日 字符型
        isAutoWithdraw: this.formInline.isAutoWithdraw
      })
        .then((res) => {
          this.total = res.total
          this.cangchuTableData = res.list
          this.formFlag = 0
          this.cangchuTableData.forEach((item, index) => {
            // （2）货主提现：资金流水非必填
            // （3）车队/司机提现：资金流水必填
            if (item.accountType == 1) {
              item.accountType = '货主'
              this.formFlag = 1
            } else if (item.accountType == 2) {
              item.accountType = '司机'
              this.formFlag = 0
            } else if (item.accountType == 3) {
              item.accountType = '车队'
              this.formFlag = 0
            } else if (item.accountType == 4) {
              item.accountType = '车队长'
              this.formFlag = 0
            } else if (item.accountType == 0) {
              item.accountType = '平台'
              this.formFlag = 1
            }
            if (item.drawalStatus == 0) {
              item.drawalStatus = '已提现'
              this.drawalStatusFlag = 0
            } else if (item.drawalStatus == 1) {
              item.drawalStatus = '提现中'
              this.drawalStatusFlag = 1
            } else {
              item.drawalStatus = '提现失败'
            }
          })
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 查询
    chaxun () {
      this.tWithdrawalInfoListS()
    },
    // 重置
    chongZhi () {
      this.formInline = {
        goodsType: '1'
      }
      this.tWithdrawalInfoListS()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.current = val
      this.tWithdrawalInfoListS()
    },
    handleSizeChangeA (val) {
      this.pagesize = val
      this.tWithdrawalInfoListS()
    },
    // --------------------提现申请------------------
    // 判断数组的每一项是否相等
    isAllEqual (array) {
      if (array.length > 0) {
        return !array.some(function (value, index) {
          return value !== array[0]
        })
      } else {
        return true
      }
    },
    // 判断数组的每一项是否等于待提现
    isAllEqual2 (array) {
			  if (array.length > 0) {
        return !array.some(function (value, index) {
				  return value !== '提现中'
        })
			  } else {
        return true
			  }
    },
    // 数组求和
    sum (arr) {
      var s = 0
      arr.forEach(function (val, idx, arr) {
        s += val
      }, 0)
      return s
    },
    // 点击提现  判断选同一用户、同一用户类型、同一钱包账户
    tiXianClick () {
      let selectionData = this.$refs.tabref.selection
      let yongHuArr = []
      let yongHuTypeArr = []
      let zhangHuArr = []
      let tiXianFlagArr = []
      let kaiHuHangArr = []
      let bankArr = []
      let orderFlagArr = []
      let costIdArr = []
      this.tiXianIds = []
      if (selectionData.length != 1) {
        DonMessage.error('请选择一条数据进行操作！')
      } else if (selectionData.length > 30) {
        DonMessage.error('请选择三十条以下（包括三十条）数据进行操作！')
      } else {
        for (let i = 0; i < selectionData.length; i++) {
          yongHuArr.push(selectionData[i].customerName)
          yongHuTypeArr.push(selectionData[i].accountType)
          zhangHuArr.push(selectionData[i].accountCode)
          tiXianFlagArr.push(selectionData[i].drawalStatus)
          kaiHuHangArr.push(selectionData[i].openingBank)
          bankArr.push(selectionData[i].bankAccount)
          orderFlagArr.push(selectionData[i].orderFlag)
          costIdArr.push(selectionData[i].costId)
          this.costId = costIdArr[0]
          this.tiXianIds.push(selectionData[i].id)
        }
        // console.log(tiXianFlagArr)
        // console.log(this.isAllEqual2(tiXianFlagArr))
        if (this.isAllEqual(yongHuArr) != false && this.isAllEqual(yongHuTypeArr) != false && this.isAllEqual(zhangHuArr) != false && this.isAllEqual(kaiHuHangArr) != false && this.isAllEqual(bankArr) != false) {
          if (this.isAllEqual(tiXianFlagArr) != false && this.isAllEqual2(tiXianFlagArr) != false) {
            this.ownerTableData = []
            let money = []
            this.ownerTableData = this.selectList
            this.ownerCustomerName = this.ownerTableData[0].customerName
            this.ownerTableData.forEach((item, index) => {
              money.push(item.drawalMoney)
            })
            this.ownerDrawalMoney = this.sum(money).toFixed(2)
            this.ownerBankAccount = this.ownerTableData[0].bankAccount
            this.ownerOpeningBank = this.ownerTableData[0].openingBank
            // console.log(this.selectList,'......')
            if (yongHuTypeArr[0] == '货主' || yongHuTypeArr[0] == '平台') {
              this.ownerMark = true
              this.zhuanZhangTimeShow = false
            } else if (yongHuTypeArr[0] == '车队长') {
              if (this.isAllEqual(orderFlagArr) == false) {
                DonMessage.error('车队长类型所勾选的数据单子类型必须一致（订单/运单）！')
              } else {
                this.ownerMark = true
                this.orderFlag = orderFlagArr[0]
                this.zhuanZhangTimeShow = true
              }
            } else if (yongHuTypeArr[0] == '司机' || yongHuTypeArr[0] == '车队') {
              this.ownerMark = true
              this.zhuanZhangTimeShow = true
            }
            if (yongHuTypeArr[0] == '平台') {
              this.accountType = '0'
            }
            if (yongHuTypeArr[0] == '货主') {
              this.accountType = '1'
            }
            if (yongHuTypeArr[0] == '车队') {
              this.accountType = '3'
            }
            if (yongHuTypeArr[0] == '司机') {
              this.accountType = '2'
            }
            if (yongHuTypeArr[0] == '车队长') {
              this.accountType = '4'
            }
          } else {
            DonMessage.error('只能选择待提现的数据进行操作！')
          }
        } else {
          DonMessage.error('只能选择同一用户、同一用户类型、同一钱包账户、同一银行卡、同一开户行进行操作！')
        }
      }
    },
    // 货主确认提现
    ownerConfirm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.listImg.length == 0) {
            DonMessage.error('请先上传凭证')
          } else {
            if (this.listImg.length == 0) {
              DonMessage.error('请选择需要上传的图片!')
            } else {
              let imgfile = new FormData()
              for (var i = 0; i < this.listImg.length; i++) {
                imgfile.append('uploadFile', this.listImg[i].raw)
                console.log(this.listImg[i].raw, ' this.listImg[i].raw')
              }
              // let numId = { changeIdPicture: this.xuanzhongArr.changeId }
              imgfile.append('params', JSON.stringify())
              this.loading1 = true
              bPayDictionaryUploadFile(imgfile)
                .then((res) => {
                  console.log(res, '313')
                  let url = res
                  // 上传图片成功后 - 调用确认提现接口
                  updateForList({
                    ids: this.tiXianIds.toString(), // id逗号分隔
                    drawalVoucher: url, // url  凭证
                    capitalSerialno: this.ownerFormData.capitalFlow, // 资金流水
                    capitalTranstime: this.ownerFormData.zhuanZhangTime, // 转账时间
                    costId: this.costId, // 钱包id
                    accountType: this.accountType, // 用户类型
                    drawalMoney: this.ownerDrawalMoney, // 提现合计金额
                    bankAccount: this.ownerBankAccount, // 银行卡号
                    orderFlag: this.orderFlag // 车队长订单/运单状态
                  })
                    .then((res) => {
                      DonMessage.success('操作成功!')
                      this.ownerMark = false
                      this.imgMark = false
                      this.listImg = []
                      this.isAddImg = false
                      this.loading1 = false
                      this.ownerDrawalMoney = '0.00'
                      this.$nextTick(() => {
                        if (this.$refs.ownerFormData !== undefined) {
                          this.$refs.ownerFormData.resetFields()
                        }
                      })
                      this.tWithdrawalInfoListS()
                    })
                    .catch((err) => {
                      this.loading1 = false

                      DonMessage.error(err.message)
                    })
                })
                .catch((err) => {
                  DonMessage.error(err.message)
                })
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 货主取消
    ownerQuxiao () {
      this.ownerMark = false
      this.imgMark = false
      this.listImg = []
      this.isAddImg = false
      // this.ownerFormData.capitalFlow = ''
      this.ownerDrawalMoney = '0.00'
      this.$nextTick(() => {
        if (this.$refs.ownerFormData !== undefined) {
          this.$refs.ownerFormData.resetFields()
        }
      })
    },
    // 弹窗关闭（右上角X）
    ownerHandleClose (done) {
      this.ownerMark = false
      this.imgMark = false
      this.listImg = []
      this.isAddImg = false
      this.ownerDrawalMoney = '0.00'
      // this.ownerFormData.capitalFlow = ''
      this.$nextTick(() => {
        if (this.$refs.ownerFormData !== undefined) {
          this.$refs.ownerFormData.resetFields()
        }
      })
    },
    // --------------------提现记录------------------
    // 提现记录列表
    getRecordList () {
      recordList(this.recordForm).then(res => {
        this.xuanzhongArr2 = []
        this.recordTableData = res.list
        this.total1 = res.total
      }).catch((err) => {
        DonMessage.error(err.message)
      })
    },
    // 表格分页
    handleCurrentChangeB (val) {
      this.recordForm.pageNo = val
      this.getRecordList()
    },
    handleSizeChangeB (val) {
      this.recordForm.pageSize = val
      this.getRecordList()
    },
    // 查询
    recordChaxun () {
      this.getRecordList()
    },
    // 重置
    recordChongZhi () {
      this.recordForm = {
        pageNo: 1,
        pageSize: 20
      }
      this.getRecordList()
    },
    // 点击选中
    dianjixuanzhongJiLu (row) {
      this.$refs.recordTableData.toggleRowSelection(row)
      this.xuanzhongArr2 = []
      this.xuanzhongArr2 = row
      console.log(this.xuanzhongArr2)
    },
    // 点击详情
    recordDetailsClick (row) {
      this.loading1 = true
      this.recordDetailsMark = true
      if (row.accountType == '1' || row.accountType == '0') { // 货主
        this.formFlag = 1
      } else if (row.accountType != '1') {
        this.formFlag = 0
      }
      this.recordCustomerName = row.customerName
      this.recordDrawalMoney = row.drawalMoney.toFixed(2)
      tWithdrawalInfoList({
        batchWithdrawalId: row.batchWithdrawalId,
        pageNo: this.current, // 页数
        pageSize: this.pagesize // 条数
      }).then(res => {
        this.loading1 = false
        this.recordDetailsTableData = res.list
      }).catch(err => {
        this.loading1 = false
        DonMessage.error(err.message)
      })
    },
    // 详情关闭
    recordDetailsClose (done) {
      this.recordDetailsMark = false
    },
    // 导出
    recordDaochu () {
      this.isDisableRecordDaochu = true
      setTimeout(() => {
        this.isDisableRecordDaochu = false // 点击一次时隔两秒后才能再次点击
      }, 3000)
      let form = {
        pageNo: this.recordForm.pageNo, // 页数
        pageSize: this.recordForm.pageSize, // 条数
        recCustomerName: this.recordForm.customerName, //
        startTime: this.recordForm.startTime, // 创建开始日 字符型
        endTime: this.recordForm.endTime // 创建结束日 字符型
      }
      // fetch(
      exportExcel(
        this.global.payName + '/tBatchWithdrawal/exportList',
        form,
        '提现记录信息表'
      )
    },
    pingZheng (row) {
      this.imgMark = true
      this.loading = false
      this.src = row.drawalVoucher
    }
  }
}
</script>
<style lang="scss" scoped>
.changeimg {
  height: 150px;
  width: 180px;
  display: flex;

  img {
    height: 100%;
  }

  span {
    margin-top: 110px;
  }
}

// /deep/ .is-active{
//   background-color:#409EFF;
//   color: #fff;
// }
.avatar-uploader {
  text-align: left !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 140px;
  height: 140px;
  line-height: 140px;
  text-align: center;
}

/deep/.el-upload--picture-card {
  background-image: url("../../../assets/images/upload2.png") !important;
  border: none !important;
}

.hidden /deep/.el-upload--picture-card {
  display: none;
}

.box1B {
  margin-left: 95px !important;

  display: flex !important;
  flex-wrap: wrap !important;

  span {
    // margin-left: 20px !important;
    line-height: 26px !important;
  }
}

.addressBoxTitle {
  div {
    font-size: 22px;
    font-style: 700;
    float: left;
    margin-right: 80px;
  }
}

.addressBoxImg {
  .ul {
    display: flex;
    flex-wrap: wrap;

    li {
      width: 150px;
      height: 150px;
      border-radius: 20px;
      overflow: hidden;
      border: 1px dashed #ccc;
      margin-right: 30px;
      text-align: center;

      img {
        height: 100%;
        width: 100%;
      }
    }
  }

  .ul2 {
    display: flex;
    flex-wrap: wrap;

    li {
      width: 150px;
      margin-right: 30px;

      text-align: center;
    }
  }
}

/deep/.inpBox .el-input__inner {
  width: 195px !important;
}

.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}

.el-form-item {
  margin-left: 10px;
}

.huoQuanChangeWarp-body-title {
  width: 100%;
  height: 35px;
  border-bottom: 1px solid #ccc;
  padding: 5px;
  box-sizing: border-box;

  span {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: #2f2f2f;
    display: inline;
    line-height: 30px;
    // margin-left: 20px;
  }
}

.chuKuZuoyeWarp {
  width: 100%;
  position: relative;
  height: 100%;

  .pags {
    width: 100%;
    text-align: center;
  }

  // border: solid 1px blue;
  .chuKuZuoyeWarp-body {
    width: 100%;
    position: absolute;

    .chuKuZuoyeWarp-body-queryIpt {
      // margin-top: 5px;
      width: 100%;

      // border: solid 1px;
      display: flex;

      ul {
        flex: 1;
        flex-direction: column;
        display: flex;

        li {
          margin-top: 5px;
          list-style: none;
        }
      }
    }

    .chuKuZuoyeWarp-body-btn {
      margin-top: 5px;
    }

    .chuKuZuoyeWarp-body-table {
      margin-top: 5px;
    }
  }

  /deep/ .el-textarea .el-textarea__inner {
    resize: none;
  }
}
.owner_top{
  width: 65%;
  display: flex;
  justify-content: space-between;
}
.owner_top2{
  width: 85%;
  display: flex;
  justify-content: space-between;
}
</style>
